<template lang="pug">
    div(v-if="validSurveyTemplate")
        v-alert.mr-md-4(
            v-if="validOpeningStatement"
            color='success'
            dense
            outlined
            text
        )
            .break-word(v-html="surveyTemplate.opening_statement")

        SurveyTemplateQuestion(
            v-if="validQuestions"
            v-for='(question, i) in surveyTemplate.survey_template_questions'
            :key='i'
            :set-survey-answer="setSurveyAnswer"
            :survey-template-question="question"
        )

        v-alert.mr-md-4(
            v-if="validClosingStatement"
            color='success'
            dense
            outlined
            text
        )
            .break-word(v-html="surveyTemplate.closing_statement")

</template>

<script lang="ts">
    import Vue from 'vue';

    // Components
    import SurveyTemplateQuestion from '@/components/survey_template_questions/survey_form.vue';

    export default Vue.extend({
        data() {
            return {
                surveyAnswers: [],
            }
        },
        methods: {
            isSurveySaveEligible() {

                // Init
                let eligible = true;

                // Verify answers
                if (this.surveyAnswers?.length > 0) {

                    // Loop through answers and if we find an answer that is required, applicable but no answer, set eligible to false
                    for (let i = 0; i < this.surveyAnswers.length; i++) {

                        // Init
                        const surveyAnswer = this.surveyAnswers[i];
                        if (!surveyAnswer) {
                            continue;
                        }

                        // Determine if we should stop survey from saving until they've answered all of the required questions
                        if (surveyAnswer.required === true && surveyAnswer.is_applicable === true && !(surveyAnswer.answer?.length > 0)) {
                            eligible = false;
                            break;
                        }
                    }
                }

                return eligible;
            },
            setSurveyAnswer(inputSurveyAnswer) {

                // Verify
                if (!inputSurveyAnswer || !(inputSurveyAnswer?.survey_template_id > 0) || !(inputSurveyAnswer.survey_template_question_id > 0) || inputSurveyAnswer?.survey_template_id !== this.surveyTemplate?.survey_template_id) {
                    return;
                }

                // Determine if we have the answer by question in the array already, if so, update fields. Otherwise push onto array
                const idx = this.surveyAnswers.findIndex(i => i.survey_template_question_id === inputSurveyAnswer.survey_template_question_id);
                if (idx >= 0) {

                    // Init
                    const existingSurveyAnswer = this.surveyAnswers[idx];
                    if (!existingSurveyAnswer) {
                        return;
                    }

                    // Set updates
                    existingSurveyAnswer.answer = inputSurveyAnswer.answer;
                    existingSurveyAnswer.is_applicable = inputSurveyAnswer.is_applicable;
                    existingSurveyAnswer.survey_template_question_option_id = inputSurveyAnswer.survey_template_question_option_id;
                } else {
                    this.surveyAnswers.push({ ...inputSurveyAnswer});
                }
            },
        },
        computed: {
            outputSurvey() {
                return {
                    is_save_eligible: this.isSurveySaveEligible(),
                    survey_answers: this.surveyAnswers,
                    survey_template_id: this.surveyTemplate?.survey_template_id,
                }
            },
            validClosingStatement() {
                return this.surveyTemplate?.closing_statement?.length > 0;
            },
            validOpeningStatement() {
                return this.surveyTemplate?.opening_statement?.length > 0;
            },
            validQuestions() {
                return this.surveyTemplate?.survey_template_questions?.length > 0;
            },
            validSurveyTemplate() {
                return this.surveyTemplate?.survey_template_id > 0;
            },
        },
        components: {
            SurveyTemplateQuestion,
        },
        props: {
            setSurvey: Function,
            surveyTemplate: Object,
        },
        watch: {
            surveyAnswers: {
                deep: true,
                handler() {
                    this.setSurvey(this.outputSurvey);
                },
            },
        },
        destroyed() {
            this.setSurvey(null);
        },
        created() {
            this.setSurvey(this.outputSurvey);
        },
    });
</script>

<style lang="scss" scoped>
</style>
